export type SupportedLanguage = "en" | "ar";

export const LANGUAGE_STORAGE_KEY = "maica-language";
export const LANGUAGE_COOKIE_KEY = LANGUAGE_STORAGE_KEY;
export const LANGUAGE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year
export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

const ACCEPT_LANGUAGE_HEADER_MAP: Record<SupportedLanguage, string> = {
  en: "en-US",
  ar: "ar-AE",
} as const;

export function resolveAcceptLanguageHeader(language?: string | null): string {
  if (language === "ar") {
    return ACCEPT_LANGUAGE_HEADER_MAP.ar;
  }

  return ACCEPT_LANGUAGE_HEADER_MAP.en;
}

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return value === "en" || value === "ar";
}

